import { defineMessages } from 'react-intl-next';

export const messages: {
	commentIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	commentIconLabel: {
		id: 'dynamic-cards-search-page.comment-icon.label',
		defaultMessage: 'Number of comments',
		description: 'Accessibility label for the comment count icon',
	},
});
